/**
 * @file
 * Provides Auth0 integration.
 */
import createAuth0Client from '@auth0/auth0-spa-js';
import { GenericError, PopupTimeoutError } from '@auth0/auth0-spa-js';

(function (Drupal, drupalSettings, $, cookies, once) {
  "use strict";

  Drupal.behaviors.biHcpValidationAuth0 = Drupal.behaviors.biHcpValidationAuth0 || {};
  Drupal.behaviors.biHcpValidationAuth0.callbackPath = '/auth0/callback';

  Drupal.behaviors.biHcpValidationAuth0.attach = async (context, settings) => {
    // Make sure that biHcpvalidation behavior exists.
    if (!Drupal.behaviors.biHcpValidation) {
      return;
    }

    const _obj = Drupal.behaviors.biHcpValidationAuth0;
    const $loginButton = $('#auth0-login', context);
    const $acceptCheckbox = $('#accept-consent', context);

    const isConsentEnabled = $acceptCheckbox.length;
    // Trigger Auth0 Login.
    $loginButton.click(async () => {
      // Only trigger login if consent is checked.
      if (isConsentEnabled && !$acceptCheckbox.prop('checked')) {
        return;
      }
      await _obj.login(context);
    });

    $(once('auth0-validation', 'body', context)).each(async () => {
      try {
        await _obj.configureClient();

        // If HCP validation cookie does not exist but still authenticated,
        // invoke auth0 logout().
        const cookie = cookies.get(drupalSettings.bi_hcp_validation.cookieName);
        const isAuthenticated = await auth0.isAuthenticated();
        if (!cookie && isAuthenticated) {
          const redirectURI = window.location.origin + drupalSettings.path.baseUrl.slice(0, -1);
          await auth0.logout({ returnTo: redirectURI });
        }
      } catch (err) {
        console.log(err);
      }
    });

  };

  /**
   * Initializes the Auth0 client
   */
  Drupal.behaviors.biHcpValidationAuth0.configureClient = async () => {
    try {
      const client = await createAuth0Client({
        domain: drupalSettings.bi_auth0.auth0Domain,
        client_id: drupalSettings.bi_auth0.auth0ClientId,
        cacheLocation: 'localstorage'
      });
      // Assign Auth0 instance to global window object.
      window.auth0 = client;
    } catch (err) {
      console.log(err);
    }
  };

  /**
   * Starts the authentication flow
   */
  Drupal.behaviors.biHcpValidationAuth0.login = async (context = document) => {
    try {
      await auth0.loginWithPopup({}, { timeoutInSeconds: 180 });

      const isAuthenticated = await auth0.isAuthenticated();
      if (isAuthenticated) {
        const user = await auth0.getUser();
        // Call a handler that sets a cookie and removes interstitial dialog
        // after user login.
        const handlePostLogin = Drupal.ajax({
          url: Drupal.url('auth0/handle_postlogin'),
          method: 'POST',
          submit: {
            'postLoginToken': drupalSettings.bi_auth0.postLoginToken,
            'user': user,
            // Return current_path and query_string for Auth0 Access module.
            'current_path': drupalSettings.path.currentPath,
            'query_string': drupalSettings.path.currentQuery
          }
        });
        await handlePostLogin.execute();
      }
    } catch (err) {
      // Check if the error is an Auth0 error type.
      if (err instanceof GenericError) {
        const { error: error_code, error_description } = err;
        // Get contents that are only visible on error state.
        const $errorMessageWrapper = $('.auth0-error-state-content--error', context);
        const $errorMessage = $('#auth0-error-message', context);
        const $logoutLinkWrapper = $('.auth0-error-state-content--logout', context);
        const $logoutLink = $('#auth0-restart-session', context);
        // Construct the Auth0 logout URL.
        const redirectURI = window.location.origin + drupalSettings.path.baseUrl.slice(0, -1);
        const logoutURL = await auth0.buildLogoutUrl({ returnTo: redirectURI });

        // Display error message on the interstitial.
        $errorMessage.text(Drupal.t(error_description));
        $errorMessageWrapper.removeClass('hidden');

        // Auth0 client returns 'access_denied' when api.access.deny() is called
        // on Auth0 "Action" functions.
        if (error_code === 'access_denied') {
          $logoutLinkWrapper.removeClass('hidden');
          $logoutLink.attr('href', logoutURL);
        }
        // Popup timeout error type
        else if (err instanceof PopupTimeoutError) {
          err.popup.close();
        }
      } else {
        // Log the error in console.
        console.error(err);
      }
    }
  };

  /**
   * Executes the logout flow
   */
  Drupal.behaviors.biHcpValidationAuth0.logout = async(returnTo) => {
    try {
      await auth0.logout({ returnTo });
    } catch (err) {
      console.log(err);
    }
  };

})(Drupal, drupalSettings, jQuery, window.Cookies, once);
